package org.vreo.devicehub.features.userAuthentication.presentation.login

import org.vreo.devicehub.features.core.presentation.UiText

/**
 * User authentication state.
 */
data class UserLoginState(
    val isLoading: Boolean = false,
    val error: UiText? = null,
    val version: String = "2.1.1",

    val emptyUsername: Boolean = false,
    val emptyPassword: Boolean = false,

    val userName: String = "",
    val password: String = "",
    val isAdmin: Boolean = false
)